import { formatCalendarDate, parseCalendarDate } from '../../dates/index.js';
/**
 * The earliest day a business date input accepts (AR as-of and ledger dates, a credit's issued and
 * expiration dates). No record predates it, and a typo year (`0026` for `2026`) is a real calendar
 * day that Temporal and a Postgres `DATE` would otherwise store.
 */
export const EARLIEST_BUSINESS_DATE = parseCalendarDate('1900-01-01');
/** What a field says when its day is real but before {@link EARLIEST_BUSINESS_DATE}. */
export function beforeEarliestBusinessDateMessage(label) {
    return `${label} must be on or after ${formatCalendarDate(EARLIEST_BUSINESS_DATE)}.`;
}
//# sourceMappingURL=earliest-business-date.js.map